import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import Home from './pages/Home';
import SearchResults from './pages/SearchResults';
import ValidationPage from './pages/ValidationPage';
import Checkout from './pages/Checkout';
import SeatSelection from './pages/SeatSelection';
import './App.css';
import Passenger from './pages/Passenger';
import ReviewSelection from './pages/ReviewSelection';


function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search-results" element={<SearchResults />} />
          <Route path="/validation" element={<ValidationPage />} />
          <Route path="/checkout" element={<Checkout />} />
          <Route path="/passenger" element={<Passenger/>} />
          <Route path="/seat-selection" element={<SeatSelection />} />
          <Route path="/reviewselection" element={<ReviewSelection />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;
